import { notFound } from './not-found'

export const PARALLEL_ROUTE_DEFAULT_PATH =
  'next/dist/client/components/parallel-route-default.js'

export default function ParallelRouteDefault() {
  notFound()
}
